export default "__VITE_ASSET__DzF4PyB4__"